module.exports = __webpack_public_path__ + "img/settings-03.db8da6f2.svg";